import { createColumnHelper } from "@tanstack/react-table"
import { useEffect, useState } from "react"
import DataTable from "../../../../components/dataTable/DataTable"
import LoadingModal from "../../../../components/loadingModal"
import { ApiEndpoints, reqGetNew, reqPostNew } from "../../../../config/apiClient"
import Select from "react-select"
import { Button } from "react-bootstrap"
import ModalEstoqueVisualizar from "./ModalVisualizarEstoque"

export default function InsumosEstoquePage() { 
    const [loading, setLoading] = useState<boolean>(false)
    const [dados, setDados] = useState<any[]>([])
    const [estoque, setEstoque] = useState<any>({})
    const [showModalEstoque, setShowModalEstoque] = useState<boolean>(false)
    
    const [filtrosDados, setFiltrosDados] = useState<any>({})
    const [empresaFiltro, setEmpresaFiltro] = useState<any>([])
    const [empresaFiltroSelected, setEmpresaFiltroSelected] = useState<any>([])
    const [produtoFiltro, setProdutoFiltro] = useState<any>([])
    const [produtoFiltroSelected, setProdutoFiltroSelected] = useState<any>([])
    const [localFiltro, setLocalFiltro] = useState<any[]>([])
    const [localFiltroSelected, setLocalFiltroSelected] = useState<any[]>([])
    
    useEffect(() => { 
        document.title = "Insumos Estoque | OB PORTUS"
        handleFiltrarManual(true)
        listarFiltros()
        // eslint-disable-next-line
    }, [])
    
    async function listarDados() { 
        let dados = {
            "id_empresa": handleParseFiltroIds(empresaFiltroSelected),
            "id_produto": handleParseFiltroIds(produtoFiltroSelected),
            "id_unidade": [],
            "id_local": handleParseFiltroIds(localFiltroSelected),
        }
        const api = await reqPostNew(ApiEndpoints.insumosConsultarEstoque, dados)
        if (api.status === 200) {
            const dadosAux:InsumoLocalDto[] = api.data
            console.log(api.data)
            setDados(dadosAux)
        }
    }
    async function listarFiltros() {
        const api = await reqGetNew(ApiEndpoints.insumosFiltrosEstoque)
        if (api.status === 200) {
            const dados = api.data
            let empresasAux = dados.empresas.map((item: any, index: any) => (
                {
                    "value": `${item.codigo}`,
                    "label": `${item.nome}`
                }
            ))
            setEmpresaFiltro(empresasAux)
            let locaisAux = dados.locais.map((item: any, index: any) => (
                {
                    "value": `${item.id_estoque_local}`,
                    "label": `${item.descricao}`
                }
            ))
            setLocalFiltro(locaisAux)
            let produtosAux = dados.produtos.map((item: any, index: any) => (
                {
                    "value": `${item.id_produto}`,
                    "label": `${item.descricao}`
                }
            ))
            setProdutoFiltro(produtosAux)
            setFiltrosDados({
                empresas: empresasAux,
                locais: locaisAux,
                produtos: produtosAux,
            })
        }
    }
    
    function tableMiddleClickhandler(event:any) {
        // const idx = Number(event.target.parentElement.getAttribute('about'))
        // const reg = dados[idx]
        // const link = `${URL_BASE}/editar?id=${reg.id_local}`
        // if (event.button === 1) {
        //     window.open(link)
        // }
    }
    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = dados[idx]
        setEstoque(reg)
        setShowModalEstoque(true)
        window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA SISTEMA INSUMOS ESTOQUE", `/insumos/estoque?reg=${reg.id_registro}`)
        // const link = `${URL_BASE}/editar?id=${reg.id_local}`
        // if (event.button === 0) {
        //     window.location.assign(link)
        // }
    }
    function handleCloseModalEstoque() { 
        setShowModalEstoque(false)
        setEstoque({})
        window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA SISTEMA INSUMOS ESTOQUE", `/insumos/estoque`)
    }
    async function handleFiltrarManual(dialogLoaing: boolean) {
        if (dialogLoaing) {
            setLoading(true)
        }
        await listarDados()
        if (dialogLoaing) {
            setLoading(false)
        }
    }
    function handleParseFiltroIds(selecionados: any[]) {
        let dados: number[] = []
        for (let registro of selecionados) {
            dados.push(Number(registro.value))
        }
        return dados
    }
    
    return (
        <div id="main">
            <LoadingModal
                show={loading}
                handleClose={(event: any) => {
                    setLoading(!loading);
                }}
            />
            
            {
                showModalEstoque && <ModalEstoqueVisualizar estoque_dados={estoque} show={showModalEstoque} handleClose={() => handleCloseModalEstoque()} filtros={filtrosDados} />
            }
            
            <div className="div-row">
                <h1 id="titleMain">Gerenciamento de Estoque</h1>
            </div>
            
            <br></br>
            
            <div className="div-row">
                <Select name='ids_empresa' id='ids_empresa' options={empresaFiltro} defaultValue={empresaFiltroSelected} placeholder="Empresas" isMulti closeMenuOnSelect={false} onChange={
                    (choice) => {
                        setEmpresaFiltroSelected(choice)
                    }
                } styles={styleSelectLocais} />
                <Select name='ids_produto' id='ids_produto' options={produtoFiltro} defaultValue={produtoFiltroSelected} placeholder="Produtos" isMulti closeMenuOnSelect={false} onChange={
                    (choice) => {
                        setProdutoFiltroSelected(choice)
                    }
                } styles={styleSelectLocais} />
                <Select name='ids_local' id='ids_local' options={localFiltro} defaultValue={localFiltroSelected} placeholder="Local" isMulti closeMenuOnSelect={false} onChange={
                    (choice: any) => {
                        setLocalFiltroSelected(choice)
                    }
                } styles={styleSelectColaboradores} />

                <Button onClick={() => { handleFiltrarManual(true) }} variant='primary' style={{ height: '40px', marginRight: "5px" }} className='div-row-space-between'>Filtrar <span className="material-symbols-outlined">filter_alt</span></Button>
                <Button onClick={() => {}} variant='success' style={{ height: '40px' }} className='div-row-space-between'>Adicionar Estoque <span className="material-symbols-outlined">add</span></Button>
            </div>
            
            <br></br>
            
            <DataTable dados={dados} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} />
        </div>
    )
}

export interface InsumoLocalDto {
    id_registro: any
    id_empresa: any
    id_produto: any
    id_unidade: any
    quantidade_atual: number
    observacao: string
    data_criacao: string
    data_alterado: string
    produtos: any[]
    historico: any[]
}

const columnHelper = createColumnHelper<InsumoLocalDto>()
const defaultColumns = [
    columnHelper.accessor('id_registro', {
        header: 'Cod.',
        size: 10,
    }),
    columnHelper.accessor(row => `${row.id_empresa.nome}`, {
        header: 'Empresa',
    }),
    columnHelper.accessor(row => `${row.id_produto.descricao}`, {
        header: 'Produto',
    }),
    columnHelper.accessor(row => `${row.quantidade_atual}`, {
        header: 'Quantidade',
    }),
    columnHelper.accessor(row => `${row.id_unidade.descricao}`, {
        header: 'Unidade',
    }),
    columnHelper.accessor(row => ``, {
        header: 'Local',
    }),
]
const defaultOrder:any = []

const styleSelectLocais = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        width: '250px',
        borderColor: "#dee2e6",
        minHeight: '39px',
        maxHeight: '120px',
        marginRight: '5px',
        fontSize: '14px'
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: '30px',
        maxHeight: '120px',
        overflowY: 'auto',
        fontSize: '14px'
    }),
    input: (provided: any, state: any) => ({
        ...provided,
        margin: '0px',
        fontSize: '14px'
    }),
    indicatorSeparator: (state: any) => ({
        display: 'none',
        fontSize: '14px'
    }),
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: '39px',
        maxHeight: '120px',
        fontSize: '14px'
    }),
    menu: (provided: any, state: any) => ({
        ...provided,
        fontSize: '14px'
    }),
}

const styleSelectColaboradores = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        width: '400px',
        borderColor: "#dee2e6",
        minHeight: '39px',
        maxHeight: '120px',
        marginRight: '5px',
        fontSize: '14px'
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: '30px',
        maxHeight: '120px',
        overflowY: 'auto',
        fontSize: '14px'
    }),
    input: (provided: any, state: any) => ({
        ...provided,
        margin: '0px',
        fontSize: '14px'
    }),
    indicatorSeparator: (state: any) => ({
        display: 'none',
        fontSize: '14px'
    }),
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: '39px',
        maxHeight: '120px',
        fontSize: '14px'
    }),
    menu: (provided: any, state: any) => ({
        ...provided,
        fontSize: '14px'
    }),
}
